export const controlAudioAction = audioData => {
  // console.log(audioData);

  return {
    type: 'CONTROL_AUDIO',
    data: audioData,
  };
};
